import React, {Component} from 'react';
import './style.scss';
import {Col, ModalHeader, Row} from "reactstrap";
import Modal from "../../../../components/Modal/Modal";
import moment from "moment";
import {Button} from "semantic-ui-react";
import Cookies from "js-cookie";
import axiosEventTags from "../../../../axios/axios_eventtag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import {
  ADMIN_NOT_APPROVED_REQUEST,
  ADMIN_REQUEST_REJECT,
  ALREADY_CHECKED_IN_USER,
  ALREADY_REGISTERED_USER
} from "../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as keys from '../../../../const/key/Key'
import {
  PARTICIPANT_APPROVED,
  PARTICIPANT_PENDING,
  PARTICIPANT_REJECTED,
  SUB_EVENT_SUBMITTED_ANSWERS
} from '../../../../const/key/Key'
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import * as Validator from "../../../../util/Validator";

let questions_ = [
  {
    question_id: 121,
    question: "Which would you rather do: wash dishes, mow the lawn, clean the bathroom, or vacuum the house?",
    priority_level: 2,
    answer_type: "MULTIPLE",
    answers: [
      {answer_id: 536, answer: "Lorem ipsum"},
      {answer_id: 537, answer: "Simply dummy"}
    ],
    is_mandatory: true
  },
  {
    question_id: 122,
    question: "What makes you laugh the most?",
    priority_level: 1,
    answer_type: "TEXT",
    is_mandatory: false
  }
]
class App extends Component {
  state = {
    uuid: '',
    eventObj: null, question_popup: false,
    isShowEventDetails: true,
    isShowModal: false,
    upcomingEventList: [],
    showHr: false,
    questions: [],
    submittedAnswers: []
  }

  closeModal = (value = null) => {
    this.props.refresh(value)
    this.props.closeHandler()
  }

  componentDidMount() {
    let {userId} = this.props;
    // let subEventAnsList = localStorage.getItem(`${keys.SUB_EVENT_SUBMITTED_ANSWERS}-${userId}`);

    let uuid = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID);
    if (uuid) {
      //subEventAnsList ? JSON.parse(subEventAnsList) : []
      this.setState({uuid: uuid, submittedAnswers: []}, () => {
        this.getEvents();
      });
    } else if (this.props.isJoin && !uuid) {
      this.getUpcomingEvents();
    } else {
      this.closeModal('NONE');
    }
  }

  getUpcomingEvents = () => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")}
    axiosEventTags.get(apiConfig.GET_UPCOMING_EVENTS,{headers: headers})
      .then(response => {
        if (response.data.success) {
          let eventList = [];
          response.data.eventList.map((event,index) => {
            event.subEventList.map((subEvent, index) => {
              eventList.push({key: subEvent.sub_event_id, text: subEvent.name, value: subEvent.qr_code});
            })
          })
          this.setState({ isShowModal: true, upcomingEventList: eventList});
          this.props.spinnerHandler(false);
        } else {
          common.warningAlert(response.data.message, 1);
          this.closeModal("NONE");
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getUpcomingEvents();
      })
      .finally(() => {
        this.props.spinnerHandler(false);
      })
  }

  getEvents = () => {
    this.setState({eventObj: null});
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")}
    axiosEventTags.get(apiConfig.GET_DYNAMIC_EVENT_DETAILS(this.state.uuid), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let {submittedAnswers} = this.state;
          let content = response.data.content;
          if (content.participant === null) {
            this.setState({isShowModal: true, eventObj: response.data.content})
            if (this.props.isJoin) this.setState({showHr: true});
          } else {
            if (content.auto_approved && !content.participant.attendance) {
              this.setState({isShowModal: true, eventObj: response.data.content})
              if (this.props.isJoin) this.setState({showHr: true});
              // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
              // common.warningAlert(ALREADY_CHECKED_IN_USER, 1);
              // if(!this.props.isJoin) this.closeModal();
            } else if (content.auto_approved && content.participant.attendance) {
              // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
              common.warningAlert(ALREADY_CHECKED_IN_USER, 1);
              if(!this.props.isJoin) this.closeModal();

            } else if (!content.auto_approved && content.participant.attendance) {
              // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
              common.warningAlert(ALREADY_CHECKED_IN_USER, 1);
              if(!this.props.isJoin) this.closeModal();
            } else if (!content.auto_approved && content.participant.participantRequestStatus === PARTICIPANT_PENDING) {
              // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
              common.warningAlert(ADMIN_NOT_APPROVED_REQUEST, 1);
              if(!this.props.isJoin) this.closeModal();
            } else if (!content.auto_approved && content.participant.participantRequestStatus === PARTICIPANT_APPROVED) {
              this.setState({isShowModal: true, eventObj: response.data.content})
              if (this.props.isJoin) this.setState({showHr: true});
            } else if (!content.auto_approved && content.participant.participantRequestStatus === PARTICIPANT_REJECTED) {
              // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
              common.warningAlert(ADMIN_REQUEST_REJECT, 1);
              if(!this.props.isJoin) this.closeModal();
            }
          }
          if(content.hasQuestionsForParticipants) {
            let questionsArr = [];
            content.subEventQuestions.map((obj,index) => {
              let findObj = submittedAnswers.length === content.subEventQuestions.length ? submittedAnswers[index] : null;
              let answersArr = [];
              if(obj.answerType === "MULTIPLE") {
                obj.answers.map(ansObj => {
                  answersArr.push({answer_id: ansObj.subEventParticipantRegistrationAnswerId, answer: ansObj.answer})
                })
              }
              questionsArr.push({
                question_id:  obj.subEventParticipantRegistrationQuestionId,
                question: obj.question,
                priority_level: obj.priorityLevel,
                answer_type: obj.answerType,
                answers: answersArr,
                is_mandatory: obj.mandatory,
                user_answer: findObj && index === 0 && answersArr.length >= findObj.ans ? answersArr[findObj.ans].answer_id : findObj ? findObj.ans : null,
                user_answer_index: findObj && index === 0 ? findObj.ans : 0
              })
            })
            this.setState({questions: questionsArr})
          }
        } else {
          common.warningAlert(response.data.message, 1);
          if(!this.props.isJoin) this.closeModal();
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getEvents();
      })
      .finally(() => {
        this.props.spinnerHandler(false);
      })
  }
  onChangeEvents = (e,{value}) => {
    this.setState({uuid: value, showHr: false, eventObj: null, question_popup: false},() => {
      this.getEvents();
    });
  }
  handleChange = (index, question_id) => event => {
    let {questions} = this.state;
    questions[index].user_answer = event.target.value;
    this.setState({questions})
  };
  tickHandler = (index, ans_id, ans_index) => {
    let {questions} = this.state;
    questions[index].user_answer = ans_id;
    questions[index].user_answer_index = ans_index;
    this.setState({questions})
  }
  render() {
    let {eventObj, uuid, isShowModal, upcomingEventList, question_popup, questions} = this.state;
    return isShowModal ? <Modal className={"static-event-wrapper"} isOpen={isShowModal} size="md" header="">
      <ModalHeader toggle={() => {this.props.isJoin ? this.closeModal("NONE") : this.closeModal()}}></ModalHeader>
      {this.props.isJoin &&
      <Row className={"d-flex align-items-center justify-content-center cmb-events"}>
        <Col md={10}>
          {/*<LabelDropdown
            tagText={"Event"}
            placeholder={"Event Name"}
            options={upcomingEventList}
            onChange={this.onChangeEvents}
          />*/}
          <DrpDwn
            required
            tagText={"Choose Event"}
            placeholder={"Select Event"}
            options={upcomingEventList}
            onChange={this.onChangeEvents}
            value={uuid}
          />
          {uuid ? <Button color={'green'} className={'search-event-q-btn'} onClick={()=>this.getEvents()}>Search</Button>:null}
        </Col>
      </Row>
      }
      {/*{this.state.showHr && <hr style={{marginBottom: "15px", marginTop: "15px"}}/>}*/}
      {eventObj && question_popup ?
        <div className={'event-reg-questions animated bounceInTop'}>
          <div className={'ques-header'}>
            <p>Event Registration Questionnaire</p>
            <p className={'sub-text'}>Answer following questions to register for the event. </p>
            <p className={'required-desc'}><span>*</span> Indicates required fields</p>
          </div>
          <div className={'ques-body'}>
            <div>
              {questions.map((obj,index)=> {
                return <div key={index} className={'ques-ans-wrapper'}>
                  <p className={`${obj.is_mandatory ? `required-lbl`:``}`}><span>{index < 9 ? `${index + 1}` : index + 1}. </span>{obj.question}</p>
                  <div className={'ques-ans'}>
                    {obj.answer_type === "MULTIPLE" ?
                      <div>
                        {obj.answers.map((ans, ans_id) => {
                            return <button className={`${obj.user_answer === ans.answer_id ? `check-btn`:``}`} key={ans_id} onClick={()=>this.tickHandler(index, ans.answer_id, ans_id)}><div className={'circle'}/>{ans.answer}</button>
                          })}
                      </div>
                    :<input placeholder={'Enter your answer here'} onChange={this.handleChange(index, obj.question_id)} value={obj.user_answer ? obj.user_answer : ""}/>}
                  </div>
                </div>
              })}
            </div>
            <div className={'ques-bottom-wrapper'}>
              <Button className={'backToLogin-btn'}  onClick={()=>this.setState({question_popup: false})}>CLOSE</Button>
              <Button className="submit-btn-ori" onClick={()=>this.validateHandler(1)}>{"SUBMIT"}</Button>
            </div>
          </div>
        </div> :
        eventObj &&
      <Row className={"m-0"}>
        <Col md={12}>
          <img className={'blur-img'} src={eventObj.icon}/>
          <img className={'normal-img'} src={eventObj.icon}/>
          {eventObj?.participant?.participantRequestStatus ? <p className={`${eventObj?.participant?.participantRequestStatus} participant-request-status`}>{eventObj?.participant?.participantRequestStatus}</p> :null}
        </Col>
        <Col md={12} className={'middle-section'}>
          <div>
            <p className={'name'}>{eventObj.name}</p>
            <p className={'sub-title'}>About this Event</p>
            <p className={'desc'}>{eventObj.description}</p>

            {eventObj.start_date ? <div className={'sm-wrapper'}>
              <img src={require('../../../../assets/img/mobile/time.png')} className={'small-icon'}/>
              <div>
                <p>{`${moment(eventObj.start_date).add(330, 'minutes').format(" hh:mm A")} - ${moment(eventObj.end_date).add(330, 'minutes').format(" hh:mm A")}`}</p>
                <p>{`${moment(eventObj.start_date).add(330, 'minutes').format("dddd, MMMM DD, YYYY")}`}</p>
              </div>
            </div> : null}
            {eventObj.location_name ? <div className={'sm-wrapper'}>
              <img src={require('../../../../assets/img/mobile/location.png')} className={'small-icon'}/>
              <div>
                {/*<p>{`${subEventList.location_name.split(",").length > 0 ? subEventList.location_name.split(",")[0] : subEventList.location_name}`}</p>*/}
                {/*{subEventList.location_name && subEventList.location_name.split(",").length > 1 ? <p className={'second-p'}>{`${subEventList.location_name.split(",")[1]}`}</p>: null}*/}
                <p>{`${eventObj.location_name}`}</p>
              </div>
            </div> : null}
          </div>
          {eventObj.contacts.length > 0 ? <div>
            <hr/>
            <p className={'sub-title'}>Event Organizer</p>
            <div>
              {
                eventObj.contacts.map((obj, i) => {
                  return <div key={i} className={'mt-1'}>
                    {obj.name ? <div className={'sm-wrapper sm-none'}>
                      <img src={require('../../../../assets/img/mobile/group-event.png')} className={'small-icon'}/>
                      <div>
                        <p>{`${obj.name}`}</p>
                      </div>
                    </div> : null}
                    {obj.email ? <div className={'sm-wrapper sm-none'}>
                      <img src={require('../../../../assets/img/mobile/envelope.png')} className={'small-icon'}/>
                      <div>
                        <p>{`${obj.email}`}</p>
                      </div>
                    </div> : null}
                    {obj.contact ? <div className={'sm-wrapper sm-none'}>
                      <img src={require('../../../../assets/img/mobile/call.png')} className={'small-icon'}/>
                      <div>
                        <p>{`${obj.contact}`}</p>
                      </div>
                    </div> : null}
                  </div>
                })
              }
            </div>
          </div> : null}
          <div>
            <hr/>
            <p className={'sub-title'}>Main Event</p>
            <div className={'main-event-lyr'}>
              <img className={'main-img'} src={eventObj.event.icon}/>
              <div className={'main-event-details'}>
                <p className={'name'}>{eventObj.event.name}</p>
                {eventObj.event.start_date ? <p
                  className={'desc'}>{`${moment(eventObj.event.start_date).format("MMM DD, YYYY")} - ${moment(eventObj.event.end_date).format("MMM DD, YYYY")}`}</p> : null}
              </div>
            </div>
          </div>
        </Col>
        <Col md={12} className={'m-0 p-0 submit-btn-wrapper'}>
          {/*eventObj.auto_approved ? "REGISTER & CHECK-IN" : "REGISTER"*/}
          {/*{eventObj ? <Button className="submit-btn-ori"*/}
          {/*                    onClick={()=>this.validateHandler(0)}>{eventObj.auto_approved ? "REGISTER" : "REGISTER"}</Button> : null}*/}
          {/*{eventObj.participant !== null &&*/}
          {/*((!eventObj.auto_approved && eventObj.participant.participantRequestStatus === PARTICIPANT_APPROVED) || (eventObj.auto_approved && !eventObj.participant.attendance)) ?*/}
          {/*  <Button className="submit-btn-ori" onClick={()=>this.validateHandler(0)}>CHECK-IN</Button> : null*/}
          {/*}*/}
          {/*--------------*/}
          {eventObj.participant !== null &&
          ((!eventObj.auto_approved && eventObj.participant.participantRequestStatus === PARTICIPANT_APPROVED) || (eventObj.auto_approved && !eventObj.participant.attendance)) ?
            null : eventObj ? <Button className="submit-btn-ori submit-btn"
                                      onClick={()=>this.validateHandler(0)}>{eventObj.auto_approved ? "REGISTER" : "REGISTER"}</Button> : null
          }
        </Col>
      </Row>
      }
    </Modal> : null;
  }

  validateHandler = (status) => {
    let {eventObj, questions, submittedAnswers} = this.state;
    if(status === 1) {
      let required_list = [];
      questions.map(obj => {
        if(obj.is_mandatory && (obj.user_answer === null || obj.user_answer.toString().trim() === "")) required_list.push(obj);
      })
      if(required_list.length !== 0) {
        return common.notifyMessage(required_list.length === 1 ? `A required question is missing. Please check again.`: `Some required questions are missing. Please check again.`, 0);
      }else{
        this.validateHandler(2);
        return;
      }
    }
    // submittedAnswers.length === 0 &&
    if(submittedAnswers.length === 0 && status !== 2 && eventObj.hasQuestionsForParticipants && (eventObj.participant === null || (!eventObj.participant.has_submitted_answers))) {
      this.setState({eventObj: null, question_popup: true});
      setTimeout(()=>{this.setState({eventObj: eventObj})},10)
      return;
    }
    swal({
      title: (this.state.eventObj.participant !== null && (!this.state.eventObj.auto_approved && this.state.eventObj.participant.participantRequestStatus === PARTICIPANT_APPROVED)) ? "Are you sure do you want to check-in for this event?" : "Are you sure do you want to register this event?",
      icon: are_you_sure_icon, closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
    }).then((value) => {
      switch (value) {
        case "action":
          (this.state.eventObj.participant !== null && (!this.state.eventObj.auto_approved && this.state.eventObj.participant.participantRequestStatus === PARTICIPANT_APPROVED)) ? this.checkInToEventHandler() : this.registerEventHandler();
          break;
        default:
          break;
      }
    })
  }
  registerEventHandler = () => {
    let {eventObj, questions} = this.state;
    let {userId} = this.props;
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")}
    const body = [];
    let staticQArray = [];
    if(eventObj.hasQuestionsForParticipants) {
      questions.map((obj,index) => {
        if(obj.answer_type === "MULTIPLE") {
          body.push({
            "subEventParticipantRegistrationQuestionId": obj.question_id,
            "subEventParticipantRegistrationAnswerId": obj.user_answer
          })
          staticQArray.push({ans: obj.user_answer_index})
        }else{
          body.push({
            "subEventParticipantRegistrationQuestionId": obj.question_id,
            "answer": obj.user_answer !== null ? obj.user_answer.toString().trim() : null
          })
          staticQArray.push({ans: obj.user_answer !== null ? obj.user_answer.toString().trim() : null})
        }
      })
    }
    // localStorage.setItem(`${keys.SUB_EVENT_SUBMITTED_ANSWERS}-${userId}`, JSON.stringify(staticQArray)); // temporary solution
    axiosEventTags.post(apiConfig.REGISTER_SUB_EVENT({eventId: eventObj.sub_event_id, userId: userId}), {answers: body}, {headers: headers})
      .then(response => {
        if (response.data.success) {
          // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
          common.warningAlert(response.data.message, 0);
          this.props.isJoin ? this.setState({eventObj: null, showHr: false, questions: [], uuid: ''}) : this.closeModal();
          // if (this.state.eventObj.auto_approved) {
          //   this.checkInToEventHandler();
          // } else {
          //   sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
          //   common.warningAlert(response.data.message, 0);
          //   this.props.isJoin ? this.setState({eventObj: null, showHr: false, questions: []}) : this.closeModal();
          // }
        } else {
          if (response.data.error_code === 409) {
            // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
            if(!this.props.isJoin) this.closeModal();
          }
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.registerEventHandler();
      })
      .finally(() => {
        this.props.spinnerHandler(false);
      });

  }

  checkInToEventHandler = () => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")}
    axiosEventTags.get(apiConfig.CHECKIN_PUBLIC_USERS({
      uuid: this.state.uuid,
      userId: this.props.userId
    }), {headers: headers})
      .then(response => {
        if (response.data.success) {
          (this.state.eventObj.participant !== null && (!this.state.eventObj.auto_approved && this.state.eventObj.participant.participantRequestStatus === PARTICIPANT_APPROVED)) ? common.warningAlert("The user has checked in for the event successfully!", 0) : common.warningAlert("The user has registered and checked in for the event successfully!", 0);
          // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
          this.props.isJoin ? this.closeModal("NONE") : this.closeModal();
        } else {
          common.warningAlert(response.data.message, 1);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.checkInToEventHandler();
      })
      .finally(() => {
        this.props.spinnerHandler(false);
      });
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(null, mapDispatchToProps)(App);
